import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSiteSettings } from '../../hooks/useSiteSettings';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}

export const SEOHead: React.FC<SEOHeadProps> = ({
  title,
  description,
  keywords,
  image,
  url
}) => {
  const { settings, loading, error } = useSiteSettings();
  
  // Site ayarlarından SEO bilgilerini al
  const seoTitle = title || settings?.seo?.metaTitle || 'Gala Raf Sistemleri';
  const seoDescription = description || settings?.seo?.metaDescription || 'Kaliteli raf ve depolama sistemleri';
  const seoKeywords = keywords || settings?.seo?.keywords || 'raf, depolama, montaj';

    // Manuel title güncelleme - React Helmet çalışmıyorsa fallback
  useEffect(() => {
    if (seoTitle && document.title !== seoTitle) {
      document.title = seoTitle;
    }
  }, [seoTitle]);


  return (
    <Helmet>
      {/* Temel meta taglar */}
      <title>{seoTitle}</title>
      <meta name="google-site-verification" content="77RF_p5rf6cPyLhS3avyxOrImnK8wLK11vrNct1A7dY" />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      {image && <meta name="twitter:image" content={image} />}
      
      {/* Dil ve charset */}
      <html lang="tr" />
      <meta charSet="utf-8" />
      
      {/* Viewport */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      
      {/* Tema rengi */}
      <meta name="theme-color" content="#ff0202" />

      <link rel="icon" type="image/png" sizes="16x16" href="/favicon.png?v=2" />
      
      {/* Canonical URL */}
      {url && <link rel="canonical" href={url} />}
    </Helmet>
  );
};